import { render } from "./General.vue?vue&type=template&id=0fee67e4&ts=true"
import script from "./General.vue?vue&type=script&lang=ts"
export * from "./General.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__